import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {submitInvestment} from "../api/RestCallHelper";
import DatePicker from "../shared/DatePicker";
import TextInput from "../shared/TextInput";
import {validateForm} from "../utils/ValidationUtil";
import FormPage from "./baseFormPage/BaseFormPage";
import FormHeader from "../shared/FormHeader";
import {FormButton} from "../styles/globalStyles";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../utils/FeedbackContext";
import ToggleButtonGroup from "../shared/ToggleButtonGroup";

export default () => {

    let location = useLocation();
    let history = useHistory();
    let dispatch = useFeedbackDispatch();

    const [investment, setInvestment] = useState({
        amount:"",
        flag:true,
        date: null,
        reason:"",
    });

    const [formValidated, setFormValidated] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);

    const clear = () => {
        setInvestment({
            amount:"",
            flag:true,
            date: null,
            reason:"",
            transactionType:""
        });
    }

    const close = (event, reason) => {
        console.log("In Investment close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    const submit = useCallback(async () => {

        // don't send again while we are sending
        if (isSending) return;

        // update state
        setIsSending(true);

        // send the actual request
        await submitInvestment(investment, dispatch, close, history, location);

        if (isMounted.current){
            //only update if we are still mounted
            setIsSending(false);
            clear()
        }

    }, [isSending, investment, location, isMounted]);

    useEffect(() => {
        setFormValidated(validateForm(investment));
        console.log("investment", investment);
    }, [investment, formValidated]);

    return (
        <FormPage
            header = {
                <FormHeader
                    heading= "Submit Investment"
                />
            }

            form = { 
                <>

                    <ToggleButtonGroup
                        value={investment.flag}
                        setValue= {(value) => (setInvestment({...investment,  flag: value}))}
                        trueOption="Deposit"
                        falseOption="Withdrawal"
                    />

                    <TextInput
                        number
                        label="Amount"
                        value={investment.amount}
                        onChange={(value) => setInvestment({ ...investment, amount: value }) }
                        style={{ margin: "10px" }}
                    />

                    <TextInput
                        multiline
                        label="Reason"
                        value={investment.reason}
                        onChange={(value) => setInvestment({ ...investment, reason: value }) }
                        style={{ margin: "10px" }}
                    />

                    <DatePicker
                        label="Date"
                        value={investment.date}
                        onChange={(value) => setInvestment({ ...investment, date: value }) }
                        style={{ margin: "10px" }}
                    />
                </>
            }

            buttons = {
                <>
                    {formValidated &&
                        <FormButton
                            disabled={isSending}
                            onClick={submit}
                        >
                            Submit
                        </FormButton>   
                    }
    
                    <FormButton
                        onClick={clear}
                        disabled={isSending}
                    >
                        Clear
                    </FormButton>
                </>
            }

        />
    );
}